import { MessageTransactionMessagePreference } from '@quorum/models/xs-resource';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

export interface MessageTransactionMessagePreferenceState extends EntityState<MessageTransactionMessagePreference> {}

export const MessageTransactionMessagePreferenceAdapter: EntityAdapter<
  MessageTransactionMessagePreference
> = createEntityAdapter<MessageTransactionMessagePreference>({
  selectId: (MessageTransactionMessagePreference: MessageTransactionMessagePreference) =>
    MessageTransactionMessagePreference.id
});
// eslint-disable-next-line max-len
export const initialMessageTransactionMessagePreferenceState: MessageTransactionMessagePreferenceState = MessageTransactionMessagePreferenceAdapter.getInitialState(
  {}
);
